module.exports = __webpack_public_path__ + "img/bundles-active.5480096.svg";